import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { Container } from "reactstrap";

import VerticalLayout from "./VerticalLayout";

const logoLight = require(`@/${process.env.REACT_APP_CUSTOMER_SIDEBAR_LOGO_LIGHT}`);
const logoDark = require(`@/${process.env.REACT_APP_CUSTOMER_SIDEBAR_LOGO_DARK}`);
const logoSm = require(`@/${process.env.REACT_APP_CUSTOMER_SIDEBAR_LOGO_SMALL}`);

const Sidebar = ({ layoutType }) => {

  useEffect(() => {
    // Register once � previously this ran on every render and stacked listeners
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay && verticalOverlay[0]) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  // Mobile: close the off-canvas sidebar after navigating to a page
  const handleMenuClick = (e) => {
    if (document.documentElement.clientWidth > 767) return;

    var link = e.target.closest("a");
    if (!link) return;

    // Parent items only expand/collapse a submenu � keep the sidebar open
    if (link.getAttribute("data-bs-toggle") === "collapse") return;

    var href = link.getAttribute("href");
    if (!href || href === "/#" || href === "#") return;

    document.body.classList.remove("vertical-sidebar-enable");
  };

  return (
    <React.Fragment>
      <style>{`
        /* Let the menu container fill the sidebar without clipping the top */
        .app-menu.navbar-menu {
          padding: 0 !important;
          display: flex;
          flex-direction: column;
        }

        /* SimpleBar takes remaining space below the brand box */
        .app-menu.navbar-menu #scrollbar {
          flex: 1 1 auto;
          min-height: 0;
          height: auto !important;
        }

        /* Breathing room so the first menu item is never tucked under the logo */
        .app-menu.navbar-menu #scrollbar .simplebar-content {
          padding-top: 8px;
          padding-bottom: calc(80px + 31px);
        }

        /* Collapsed sidebar: brand box shrinks, so re-align the menu start */
        [data-sidebar-size="sm"] .app-menu.navbar-menu .navbar-nav,
        [data-sidebar-size="sm-hover"] .app-menu.navbar-menu .navbar-nav {
          padding-top: 60px;
        }
      `}</style>

      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box mt-1">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="40" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="40" />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        <React.Fragment>
          <SimpleBar id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav" onClick={handleMenuClick}>
                <VerticalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </SimpleBar>
          <div className="sidebar-background"></div>

          <center>
            <div className="text-muted pt-2">
              <strong>Globo {process.env.REACT_APP_VERSION}</strong>
            </div>
          </center>
        </React.Fragment>

      </div>
      <div className="vertical-overlay"></div>

    </React.Fragment>
  );
};

export default Sidebar;
